import type { ComponentProps } from 'react';
import { cn } from '../lib/cn';

/** Liczby, czas, kwoty, identyfikatory i kody (JetBrains Mono Medium, cyfry tabelaryczne). */
export function Mono({ className, ...props }: ComponentProps<'span'>) {
  return <span className={cn('font-mono font-medium tabular', className)} {...props} />;
}
